'use client';
import HeaderCartIcon from '@/components/icons/header-cart-icon';
import useCart from '@/store/cart.store';
import { useTranslations } from 'next-intl';
import { useCallback, useRef } from 'react';
import MiniCart from './mini-cart';

const MINI_CART_VIEW_COOLDOWN = 5000; // 5 seconds debounce

const CartPopup = () => {
  const t = useTranslations('common');
  const cartItems = useCart((state) => state.cartItems);
  const cart = useCart((state) => state.cart);
  const total_segments = useCart((state) => state.totalSegments);
  const lastFiredRef = useRef(0);

  const handleMiniCartHover = useCallback(() => {
    const now = Date.now();
    if (
      cart?.items?.length > 0 &&
      now - lastFiredRef.current > MINI_CART_VIEW_COOLDOWN
    ) {
      lastFiredRef.current = now;
    }
  }, [cart]);

  return (
    <div
      className='group relative hidden items-center gap-[8.1px] lg:flex'
      onMouseEnter={handleMiniCartHover}
    >
      <span className='relative'>
        <HeaderCartIcon className='size-[16.81px]' />
        {cartItems?.length > 0 ? (
          <span className='absolute -end-2 -top-2 z-10 flex size-3.5 items-center justify-center rounded-full bg-[#8B0000] text-[10px] font-bold text-white'>
            {cartItems?.length}
          </span>
        ) : null}
      </span>
      <div className='flex items-center text-[#222]'>
        <span className='text-[15.8px] font-bold'>{t('Cart')}</span>
      </div>
      <MiniCart
        cartItems={cartItems}
        total={
          total_segments?.find((e) => e?.code === 'grand_total')?.value ?? 0
        }
      />
    </div>
  );
};

export default CartPopup;
